(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apex-coupon"] && !Shopify.designMode) return;
  try {
    
  
  var percent = 12;
  var var_type = "percent"
  
  const percentEl = document.querySelector("[data-coupon-value]");
  
  if (percentEl) {
    percent = parseInt(percentEl.getAttribute("data-coupon-value"));
    var_type = percentEl.getAttribute("data-coupon-type");
  }
  
  if (var_type == "percent") {
    // percent = Number(Number(percent).toFixed(2) * 100 * 1).toFixed(0);
    const priceListTags = document.getElementsByClassName("price-list");
    const salePriceTags = document.getElementsByTagName("sale-price");
    const couponElement = document.createElement("div");
    
    couponElement.innerText = `Extra ${percent}% off coupon`;
    couponElement.className = "coupon";
    
    const totalSalePriceElement = document.createElement("div");
    totalSalePriceElement.className = "total-sale-price";

    console.log(couponElement.innerText)
    
    for (let i = 0; i < priceListTags.length; i++) {
      
      const price = parseFloat(
        salePriceTags[i].innerText.replace(/[a-zA-Z$€\s]+/, "")
      );
      console.log(price)
      const totalSalePrice = price - (price * percent) / 100;
      totalSalePriceElement.innerHTML = `<span class="font-bold">$${totalSalePrice.toFixed(
        2
      )}</span> after coupon`;
      priceListTags[i].after(totalSalePriceElement.cloneNode(true));
      priceListTags[i].after(couponElement.cloneNode(true));
    }
    
  } else if (var_type == "fixed") {
    const priceListTags = document.getElementsByClassName("price-list");
    const salePriceTags = document.getElementsByTagName("sale-price");
    const couponElement = document.createElement("div");
    couponElement.innerText = `Extra $${percent} off coupon`;
    couponElement.className = "coupon";
    const totalSalePriceElement = document.createElement("div");
    totalSalePriceElement.className = "total-sale-price";
  
    for (let i = 0; i < priceListTags.length; i++) {
      const price = parseFloat(
        salePriceTags[i].innerText.replace(/[a-zA-Z€$\s]+/, "")
      );
      const totalSalePrice = price - percent;
      totalSalePriceElement.innerHTML = `<span class="font-bold">$${totalSalePrice.toFixed(
        2
      )}</span> after coupon`;
      priceListTags[i].after(totalSalePriceElement.cloneNode(true));
      priceListTags[i].after(couponElement.cloneNode(true));
    }
  }

  } catch(e) { console.error(e); }
})();
})();
